import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { NameRunwayEnum } from '@shared/models/bus-zone.model';
import { RouteBusFromAPIMapper, StopBusFromAPIMapper } from '@shared/utils/mappers/geo-api-map';
import { GeometryTypeEnum, ILayerModel } from '@types-custom/models/business/marker.model';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class BusService {

  stopsFilterNotifier$ = new Subject<any>();
  routesFilterNotifier$ = new Subject<any>();
  filter$ = new BehaviorSubject<any>(undefined);

  constructor(
    private httpClient: HttpClient,
    @Inject('environment') private environment: any
  ) { }

  getRouteBusGeoJson(lineId: string): Observable<any> {
    if (lineId) {
      return this.httpClient.get<any>(`${this.environment.runwayUrl}/runway/${NameRunwayEnum.Rutas}`).pipe(
        // return this.httpClient.get<any>(`http://34.69.231.124:8600/geoserver/RutasAlmeria/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=RutasAlmeria%3AParadas&maxFeatures=400&outputFormat=application%2Fjson`).pipe(
        map((data: any) => {
          if (data && data.features) {
            // Filtrar los elementos de 'features' según una condición específica en 'properties'
            data.features = data.features.filter((feature: any) => {
              return feature.properties && feature?.properties?.refname.includes(lineId);
            });
          }
          return data;
        })
      );
    } else {
      return this.httpClient.get<any[]>(
        //'assets/mock/rutas.json'
        `${this.environment.runwayUrl}/runway/${NameRunwayEnum.Rutas}`
        // `http://34.69.231.124:8600/geoserver/RutasAlmeria/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=RutasAlmeria%3AParadas&maxFeatures=400&outputFormat=application%2Fjson`
      );
    }

  }

  getStopBusGeoJson(stopId: string): Observable<any> {
    if (stopId) {
      return this.httpClient.get<any>(`${this.environment.runwayUrl}/runway/${NameRunwayEnum.Paradas}`).pipe(
      // return this.httpClient.get<any>(this.environment.almeriaRunwayUrl).pipe(
        map((data: any) => {
          if (data && data.features) {
            // Filtrar los elementos de 'features' según una condición específica en 'properties'
            data.features = data.features.filter((feature: any) => {
              return feature.properties && feature?.id == `Paradas.${stopId}`;
            });
          }
          return data;
        })
      );
    } else {
      return this.httpClient.get<any[]>(
        //'assets/mock/paradas.json'
        `${this.environment.runwayUrl}/runway/${NameRunwayEnum.Paradas}`
        // this.environment.almeriaRunwayUrl
      );
    }
  }

  getRouteBusMapper(parkingSource: any): ILayerModel[] {
    const layer: ILayerModel[] = [];
    const source: any = {
      type: 'FeatureCollection',
      features: parkingSource?.features,
    };

    const parkingLines = source.features.map((e: any) =>
      RouteBusFromAPIMapper(e)
    );

    layer.push({
      marker: parkingLines,
      geometryType: GeometryTypeEnum.MultiLineString,
      feature: source,
      visibility: true,
    });

    return layer;
  }

  getStopBusMapper(parkingSource: any): ILayerModel[] {
    const layer: ILayerModel[] = [];

    const source: any = {
      type: 'FeatureCollection',
      features: parkingSource.features,
    };

    const parkingPoints = source.features.map((e: any) =>
      StopBusFromAPIMapper(e)
    );

    layer.push({
      marker: parkingPoints,
      geometryType: GeometryTypeEnum.Point,
      feature: source,
      visibility: true,
    });

    return layer;
  }

  public setFilter(filter: any): void {
    this.filter$.next(filter);
  }

  public getFilter() {
    return this.filter$;
  }

}
